import { useMemo, useState } from "react";
import { Typography, Box, Menu, MenuItem, ListItemText } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const TelecallerDropdown = ({
  value = "",
  telecallers = [],
  onSelect,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const items = useMemo(() => {
    if (!Array.isArray(telecallers) || telecallers.length === 0) return [];

    if (typeof telecallers[0] === "string") {
      return telecallers.map((tc) => ({ id: tc, label: tc }));
    }

    return telecallers
      .filter((t) => t && (t.id || t._id) && (t.label || t.name))
      .map((t) => ({
        id: t.id || t._id,
        label: t.label || t.name,
      }));
  }, [telecallers]);

  const currentLabel = items.find((x) => x.id === value)?.label || "";

  return (
    <>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          "&:hover": { opacity: 0.7 },
        }}
      >
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 500,
            color: "#475569",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 160,
          }}
        >
          {currentLabel || "Unknown"}
        </Typography>
        <KeyboardArrowDownIcon sx={{ fontSize: 14, color: "#94A3B8" }} />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 200,
            maxHeight: 280,
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            borderRadius: 2,
          },
        }}
      >
        {items.map((tc) => (
          <MenuItem
            key={tc.id}
            onClick={() => {
              onSelect?.(tc.id);
              setAnchorEl(null);
            }}
            selected={tc.id === value}
          >
            <ListItemText primary={tc.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
